//service.js
import gql from "graphql-tag";
import store from "../store";

const Myapollo = function(Vue, options) {
  Vue.prototype.$Myapollo = {
    getExhibitionInfo(that, id, userId) {
      // 获取展会信息
      var exhibitionGql = gql`
        query($id: Guid!) {
          exhibition(id: $id) {
            address
            banner
            banners(position: "show.page.home") {
              covers #封面 多个用;隔开
              content #内容
              enabledCountdown #是否启用倒计时
              exhibitionId #展会Id
              url #链接
              endAt
              createAt
              showIndex
            }
            city
            commentCount
            coordinate
            country
            createAt
            endDate
            followCount
            hallName
            helpMoney
            hallPanorama
            host {
              address
              createAt
              id
              isDeleted
              linkName
              logo
              name
              phone
              remark
              shortName
              updateAt
            }
            id
            industry
            isDeleted
            logo
            name
            nameEn
            province
            remark
            remarkEn
            shareCount
            shortName
            shortNameEn
            startData
            talkCount
            updateAt
            userCount
            video
            viewCount
            organization
          }
        }
      `;
      that.$store.commit("setExhibitionId", id);
      return new Promise((resolve, reject) => {
        that.$apollo.addSmartQuery("exhibition", {
          query: exhibitionGql,
          variables: {
            id: id,
          },
          fetchPolicy: "network-only", //清理缓存
          result({ data, loading, networkStatus }) {
            if (data && data.exhibition) {
              // console.log(data,'res展会信息')
              let res = JSON.parse(JSON.stringify(data));
              if (res) {

                that.$store.commit("setExhibitionInfo", res);
                that.$store.commit("setHostInfo", res.exhibition.host);
                // getExhibitionConfig(that,id)
                 console.log(res,'apollo.js第二个');
                // 解析结束时间
                const endDate = new Date(res.exhibition.endDate);
                
                // 如果日期解析失败，返回false（允许访问）
                if (isNaN(endDate.getTime())) {
                return false;
                }
                // 获取当前时间
                const currentDate = new Date();
                // 计算6个月前的时间
                const sixMonthsAgo = new Date();
                sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
                
                // 如果结束时间早于6个月前，则超过6个月
                if(endDate < sixMonthsAgo){
                   that.$router.replace({ path: '/exTimeout' })
                    return
                }

                let exConfigGql = gql`
                  query exhibitionConfig($exhibitionId: Guid!) {
                    exhibitionConfig(exhibitionId: $exhibitionId) {
                      display {
                        #展会显示方式设置
                        boothLink #展位连接符
                        exhibitorWapLogo #移动端展商Logo显示方式 Round/0：圆形、Square/1：方形
                        showExhibitorCount #显示展商数（展商列表）
                        showViewCount #显示浏览数量（首页）
                        enabledExhibitorLimitNumber
                        exhibitorLimitNumber
                        webHomeModulesJsonEn
                        enabledCustomMTab
                        enabledCustomQuick
                        homeActivity {
                          col
                          row
                        }
                        homeExhibitorLogo {
                          col
                          row
                        }
                        showExhibitorCount
                        showViewCount
                      }
                      maxExhibitorNumber
                      visitorReg {
                        #参观注册设置
                        notice #参观须知
                        regLink #自定义登记链接
                        regSuccessedNotice #注册完成提醒
                        regSuccessedNoticeEn
                      }
                      feature {
                        enabledDataStatistics
                        enabledArticle
                        enabledBrandExhibitor
                        enabledSupplyDemand
                        enabledSpecialLive
                        enabledConcurrentActivity
                        enabledNearbyExhibitor
                        enabledRecommendForYou
                        enabledBmm
                        enabledExhibitionVisitorReg
                        enabledSwitchLanguage
                        enabledActivityCategory
                        enabledExhibitorLive
                        enabledContacts
                        enabledExhibitorCorrection
                        enabledShareDispalyOrigin
                        enabledExhibitionSurvey
                        enabledExhibitionVideo
                        enabledExhibitionTalk
                      }
                      invitation {
                        backgroundColor
                        backgroundUrl
                        topToContent
                      }
                      invitationEn {
                        backgroundColor
                        backgroundUrl
                        topToContent
                      }
                      enabledAutoAuditActivity
                      enabledAutoAuditExhibitor
                      enabledAutoAuditLive
                      enabledAutoAuditProduct
                      enabledAutoAuditSample
                      enabledAutoAuditSupplyDemand
                      exhibitorsLoadProductNumber
                      enabledAutoAuditTheme
                    }
                  }
                `;
                // console.log(id)
                that.$apollo.addSmartQuery("exhibitionConfig", {
                  query: exConfigGql,
                  variables: {
                    exhibitionId: id,
                  },
                  fetchPolicy: "network-only", //清理缓存
                  result(res1) {
                    // console.log(res1,'哈哈 配置')
                    if (res1) {
                      let dat = JSON.parse(JSON.stringify(res1.data.exhibitionConfig));
                      that.$store.commit("setExhibitionConfig", dat);
                    }
                  },
                  error(error) {
                    console.log(error);
                  },
                });
              }
              resolve(res);
            }
            resolve(data);
          }, // 错误处理
          error(error) {
            console.error(error, "error错误处理");
            reject(error);
          },
        });
      });
    },
    getUserInfoNoLogin(that) {
      if (!that.$store.getters.getToken) {
        return;
      }
      return new Promise((resolve, reject) => {
        let currentMemberGql = gql`
        query{
          currentMember{
            address
            avatarUrl
            balance
            birthday
            businessCard
            city
            company
            country
            flagStyle
            county
            createAt
            department
            id
            introduction
            jobTitle
            jobTitleEn
            name
            nameEn
            nickName
            phoneText
            phone
            province
            title
            userId
            email
            emailConfirmed
            inMember(exhibitionId:"${store.state.exhibitionId}"){
              id
              memberId
              userRole
              category
              exhibitionId
              exhibitorId
              isBlacklist
              companyUsers{
                id
                isAppointment
                linkName
                linkNameEn
                company{
                  nameEn
                }
              }
            }
          }
        }
        `;
        that.$apollo.addSmartQuery("currentMember", {
          query: currentMemberGql,
          fetchPolicy: "no-cache", //清理缓存
          result(res) {
            if (res) {
              console.log("获取用户信息");
              let data = JSON.parse(JSON.stringify(res.data.currentMember));
              that.$store.commit("setUserInfo", data);
              that.$store.commit("setUserId", data.userId);
              that.$store.commit("setUserRole", data.inMember.userRole);
              resolve(data);
            }
            resolve(res);
          }, // 错误处理
          error(error) {
            console.error(error, "error错误处理");
            if (error.toString().indexOf("not authorized") != -1) {
              that.$router.push({
                path: "/auth",
              });
            } else {
              console.log("用户");
              console.error(error, "error错误处理");
            }
            reject(error);
          },
        });
      });
    },
    getUserInfo(that) {
      console.log("请求用户信息之前login 是否微信 token", that.$store.getters.getLogin.login, that.$store.getters.getIsWeixin, that.$store.getters.getToken);
      if (!that.$store.getters.getToken) {
        return;
      }
      return new Promise((resolve, reject) => {
        let currentMemberGql = gql`
        query{
          currentMember{
            address
            avatarUrl
            balance
            birthday
            businessCard
            city
            company
            country
            flagStyle
            county
            createAt
            department
            id
            introduction
            jobTitle
            jobTitleEn
            name
            nameEn
            nickName
            phoneText
            phone
            province
            title
            userId
            email
            emailConfirmed
            inMember(exhibitionId:"${store.state.exhibitionId}"){
              id
              memberId
              userRole
              category
              exhibitionId
              exhibitorId
              isBlacklist
              companyUsers{
                id
                isAppointment
                linkName
                linkNameEn
                company{
                  nameEn
                }
              }
            }
          }
        }
        `;
        that.$apollo.addSmartQuery("currentMember", {
          query: currentMemberGql,
          fetchPolicy: "no-cache", //清理缓存
          result(res) {
            if (res) {
              console.log("获取用户信息");
              let data = JSON.parse(JSON.stringify(res.data.currentMember));
              that.$store.commit("setUserInfo", data);
              that.$store.commit("setUserId", data.userId);
              that.$store.commit("setUserRole", data.inMember.userRole);
              resolve(data);
            }
            resolve(res);
          }, // 错误处理
          error(error) {
            console.error(error, "error错误处理");
            if (error.toString().indexOf("not authorized") != -1) {
              that.$router.push({
                path: "/auth",
              });
            } else {
              console.log("用户");
              console.error(error, "error错误处理");
            }
            reject(error);
          },
        });
      });
    },
    //添加展会访问量
    addExhibitionView() {
      console.log("过来添加");
      let opt = {
        exhibitionId: store.state.exhibitionId,
        target: "exhibition",
        targetId: store.state.exhibitionId,
      };
      if (store.state.userInfo && store.state.userInfo.userId) {
        opt.userId = store.state.userInfo.userId;
      }
      store.dispatch("addAllView", opt);
    },
    unverifiedDialog(that, isReg = false, exhibitionId = "", opt = null) {
      if (isReg) {
        that.$dialog
          .confirm({
            message: "Please register first",
            className: "reg_dialog",
            cancelButtonText: "Cancel",
            confirmButtonText: "Register",
          })
          .then(() => {
            that.$store.dispatch("linkTo/LinkToReg", opt);
            // that.$router.push({path:`/visite/${exhibitionId}`})
            // on close
          })
          .catch(() => {});
      } else {
        that.$dialog
          .confirm({
            message: "请先完善资料再进行操作",
            className: "reg_dialog",
            confirmButtonText: "前往完善",
          })
          .then(() => {
            that.$router.push({ path: "/fillData" });
            // on close
          })
          .catch(() => {});
      }
    },
    NoUserInfo(that) {
      that.$dialog
        .confirm({
          message: "Please sign in first",
          className: "reg_dialog",
          cancelButtonText: "Cancel",
          confirmButtonText: "Sign in",
        })
        .then(() => {
          that.$store.dispatch("linkTo/LinkToLogin");
          // that.$router.push({path:`/visite/${exhibitionId}`})
          // on close
        })
        .catch(() => {});
    },
    // 根据主办id获取展品类别
    getCategory(that, hostId) {
      var categoriesGql = gql`
        query($hostId: Guid!) {
          categories(hostId: $hostId) {
            childrens {
              createAt
              icon
              id
              isDeleted
              level
              name
              nameEn
              parentId
              shortName
              shortNameEn
              showIndex
              updateAt
            }
            createAt
            icon
            id
            isDeleted
            banners
            level
            name
            nameEn
            parentId
            shortName
            shortNameEn
            showIndex
            updateAt
          }
        }
      `;
      return new Promise((resolve, reject) => {
        that.$apollo.addSmartQuery("categories", {
          query: categoriesGql,
          variables: {
            hostId: hostId,
          },
          result({ data, loading, networkStatus }) {
            if (data) {
              that.$store.commit("setCategory", data.categories);
            }
            resolve(data);
          }, // 错误处理
          error(error) {
            console.error(error, "error错误处理");
            reject(error);
          },
        });
      });
    },
    // 根据展会id获取展馆
    getHall(that) {
      var HallGql = gql`
        query($exhibitionId: Guid!) {
          getAllExHall(exhibitionId: $exhibitionId) {
            description
            id
            name
            showIndex
          }
        }
      `;
      return new Promise((resolve, reject) => {
        that.$apollo.addSmartQuery("getAllExHall", {
          query: HallGql,
          variables: {
            exhibitionId: store.state.exhibitionId,
          },
          result({ data }) {
            // console.log(data,'获取展馆')
            // if(data){
            //     that.$store.commit("setCategory", data.categories);
            // }
            resolve(data.getAllExHall);
          }, // 错误处理
          error(error) {
            console.error(error, "error错误处理");
            reject(error);
          },
        });
      });
    },
  };
};

export default Myapollo;
